<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <el-card class="box-card" :body-style="{ height: '100%' }">
           <transition mode="out-in" appear name="moveCartoon">
          <router-view></router-view>
        </transition>
         
        </el-card>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from "../components/navcon.vue";
import leftnav from "../components/leftnav.vue";
export default {
  name: "index",
  data() {
    return {
      showclass: "asideshow",
      showtype: false,
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav,
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    this.$message({
      message: "登录成功",
      type: "success",
    });
  },
};
</script>
<style>
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  height: 100%;
  overflow: hidden !important;
  border-left: 2px solid #333;
  box-sizing: border-box !important;
}
.el-main {
  box-sizing: border-box;
}
.el-card {
  box-sizing: border-box !important;
  height: 99%;
  overflow-y: auto;
}
.el-card__body {
  box-sizing: border-box !important;
}
/* .moveCartoon-enter,
.moveCartoon-leave-to {
  opacity: 0;
}

.moveCartoon-enter-active,
.moveCartoon-leave-acitve {
  transition: opacity 1s;
} */


  .moveCartoon-enter,
  .moveCartoon-leave-to {
    opacity: 0;
    transform: translateX(-30px);
  }
  /*  */
  .moveCartoon-enter-active {
    transition: all 0.3s;
  }
  /* 结束 */
  .moveCartoon-enter-to {
    opacity: 1;
  }
  .moveCartoon-leave-active {
    transition: all 0.3s;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue